export function toList(val) {
  if (val === false) {
    return [false, false];
  }
  return Array.isArray(val) ? val : [val];
}
export function getNode(dom, defaultNode, needDom) {
  if (dom === true || dom === undefined) {
    return defaultNode;
  }
  return dom || needDom && defaultNode;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/typography/Base/util.js
// module id = 4142
// module chunks = 0